(function() {
    // BTOCSITE-26022, PDP 컴포넌트 초기화 함수 추가, type: PROD or CONTENTS
    function SAVE_COMPONENT_PDP_DOM_MNG() {
        if (typeof __PDP_DOM_MNG__ === 'undefined') return;
        __PDP_DOM_MNG__.add({
            type: 'CONTENTS', name: 'KRC0026', isFirstLoad: false, fn: function () {
                if(!document.querySelector('.KRC0026')) return false;
                $('.KRC0026').buildCommonUI();
            }
        });
    }

    SAVE_COMPONENT_PDP_DOM_MNG();

    $(window).ready(function(){
        SAVE_COMPONENT_PDP_DOM_MNG();

        if(!document.querySelector('.KRC0026')) return false;
        $('.KRC0026').buildCommonUI();
    });
})();

